//  Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved.

import { Component, OnInit } from '@angular/core';
import { ConfigurationService } from '../../../services/configuration-service';
import { Partners } from '../../../types/partners';

@Component({
    selector: 'app-indirect-login-success',
    templateUrl: './indirect-login-success.component.html',
    styleUrls: ['./indirect-login-success.component.scss'],
    standalone: false
})
export class IndirectLoginSuccessComponent implements OnInit {
  cigentPartner = Partners.Cigent;
  doqubizPartner = Partners.Doqubiz;
  digistorPartner = Partners.Digistor;
  kanguruPartner = Partners.Kanguru;
  lenovoPartner = Partners.Lenovo;
  partnerId: Partners = Partners.Cigent;
  currentYear = new Date().getFullYear();

  constructor(private configuration: ConfigurationService) {
    this.partnerId = this.configuration.partnerId ?? Partners.Cigent;
  }

  ngOnInit(): void {
  }

}
